
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IFlowStartupReferenceDTO } from 'dto/IFlowStartupReferenceDTO';

@Component({
  name: 'ExtendTimeoutPlumb',
})
export default class FlowBoPropertyEditor extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  startupType: IFlowStartupReferenceDTO;

  @Prop({
    type: Object,
    required: true,
  })
  value: { name: string; value: string };

  get currentSelectedProperty() {
    if (this.value == null) return null;
    if (this.startupType == null) return null;
    return this.startupType.properties.find((st) => st.name === this.value.name);
  }

  updatePropertyValue(value) {
    this.$emit('input', {
      ...this.value,
      value,
    });
  }

  updatePropertyName(value) {
    this.$emit('input', {
      name: value,
      value: null,
    });
  }
}
